import React from 'react';
import classnames from 'classnames';
import { Button } from '@guildeducationinc/recess';
import ChevronRightIcon from '@guildeducationinc/recess/icons/ChevronRightIcon';
import ActionCard from '@shared/ActionCard/ActionCard';
import ActionCardButtons from '@shared/ActionCard/ActionCardButtons';
import ActionCardContent from '@shared/ActionCard/ActionCardContent';
import { CardContent } from '@shared/interfaces/CardContent';
import Skeleton from '@src/components/Shared/Skeleton/Skeleton';
import { clickable } from '@src/analytics';
import './CarouselCard.scss';

interface CarouselCardProps extends CardContent {
  analyticsId?: string;
  customClick?: () => void;
  product?: string;
  highlighted?: boolean;
}

const CarouselCard: React.FC<CarouselCardProps> = ({
  link,
  icon,
  analyticsId,
  customClick,
  product = 'home',
  highlighted = false,
  ...content
}) => {
  const actionCardClassNames = classnames('flex--1', 'padding--top_32', {
    carouselCardHighlighted: highlighted,
  });

  return (
    <ActionCard icon={icon} iconAlign='top' className={actionCardClassNames}>
      <Skeleton>
        <ActionCardContent {...content} />
      </Skeleton>
      <ActionCardButtons>
        <Skeleton>
          <Button
            aria-label={link?.ariaLabel}
            disabled={!!link?.disabled}
            href={link?.href}
            target={link?.newTab ? '_blank' : undefined}
            appearance={highlighted ? 'primary' : 'outline'}
            className={highlighted ? undefined : 'padding--x_0'}
            iconDirection='right'
            icon={!link?.newTab ? <ChevronRightIcon size={16} /> : undefined}
            newWindowIcon={link?.newTab}
            newWindowNotification={link?.newTab}
            onClick={() => {
              clickable({
                loggedIn: true,
                tag: analyticsId || 'carousel_card',
                text: link.body.split(' ').join('_').toLowerCase(),
                type: highlighted ? 'button' : 'link',
                product,
              });
              customClick && customClick();
            }}
          >
            {link?.body}
          </Button>
        </Skeleton>
      </ActionCardButtons>
    </ActionCard>
  );
};

export default CarouselCard;
